<template>
  <div>
    <section class="mt-5">
      <Gen69 :staffData="staffData" />

      <div class="flex justify-center gap-4 w-full mt-10 pb-7">
        <div style="width: 35%">
          <button
            @click="printPrintout"
            class="flex justify-center w-full gap-5 py-2.5 rounded text-white bg-idBlued"
          >
            <Icon icon="mdi:printer" class="w-7 h-7" />
            <span>Print</span>
          </button>
        </div>

        <div v-if="$route.name == 'Home'" style="width: 35%">
          <button
            @click="closeForm"
            class="border border-gray-400 text-black w-full py-2.5 rounded"
          >
            Close
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import Gen69 from "@/components/admin/staff/Gen69.vue";
export default {
  name: "StaffGen69",

  components: {
    Gen69,
    Icon,
  },

  data() {
    return {
      getting: false,
      sending: false,
      notFound: true,
      staffData: {},
    };
  },

  async created() {
    // await this.getData();
    this.staffData = { id: this.$route.params.genId };
  },

  methods: {
    printPrintout() {
      const mywindow = window.open("", "", "");
      const divContents = document.getElementById("printout").innerHTML;
      mywindow.document.write("<html><head><title></title>");
      mywindow.document.write(
        ' <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/2.2.19/tailwind.min.css">'
      );
      mywindow.document.write("</head><body>");

      const links = document.querySelectorAll("style");
      links.forEach(function (link) {
        mywindow.document.head.appendChild(link.cloneNode(true));
      });

      mywindow.document.write("<div style='margin-top:20px;'></div>");
      mywindow.document.write(divContents);
      mywindow.document.write("</body></html>");
      mywindow.document.close();
      mywindow.focus();
      setTimeout(() => {
        mywindow.print();
        mywindow.close();
        return true;
      }, 1000);
    },
  },
};
</script>

<style scoped>
@media print {
  .singlePrintout {
    page-break-after: always;
  }
}
</style>
